import dayjs from 'dayjs';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import timezone from 'dayjs/plugin/timezone';
import { BrowserTracing } from '@sentry/tracing';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { barberProfilesReducer, initialState as barberProfiles } from './reducers/barberProfilesReducer';
import { reviewSignUpBoolReducer, initialState as SigUpModalReviewState } from './reducers/reviewModalAuthReducer';
import { BarberProfilesProvider } from './context/barberProfiles';

import { accountDataReducer, initialState as accountData } from './reducers/accountDataReducer';
import { AccountDataProvider } from './context/accountData';

import { countriesReducer, initialState as countries } from './reducers/countriesReducer';
import { CountriesProvider } from './context/countries';

import { SignUpReviewModalProvider } from 'context/reviewModalAuth';

import './styles/style.scss';

dayjs.extend(timezone);
dayjs.tz.setDefault('Etc/UTC');

Sentry.init({
  environment: process.env.REACT_APP_ENVIRONMENT,
  dsn: 'https://c75f060ca6734529a3311107caeb624f@o500776.ingest.sentry.io/6236967',
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

// if (module.hot) {
//   module.hot.accept();
// }

ReactDOM.render(
  <React.StrictMode>
    <CountriesProvider initialState={countries} reducer={countriesReducer}>
      <AccountDataProvider initialState={accountData} reducer={accountDataReducer}>
        <BarberProfilesProvider initialState={barberProfiles} reducer={barberProfilesReducer}>
          <SignUpReviewModalProvider initialState={SigUpModalReviewState} reducer={reviewSignUpBoolReducer}>
            <App />
          </SignUpReviewModalProvider>
        </BarberProfilesProvider>
      </AccountDataProvider>
    </CountriesProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
